

import axios from 'axios';
import { ref } from 'vue';

export function useLinkPreview() {
  const previews = ref({});

  const fetchLinkPreview = async (url) => {
    if (!url) return null;

    try {
      const { data } = await axios.get('/api/proxy/link-preview', {
        params: { url }
      });
      console.log("Fetching link preview link", data);
      previews.value[url] = data;
      return data;
    } catch (error) {
      console.warn(`Failed to fetch link preview for ${url}:`, error);
      return null;
    }
  };

  return {
    previews,
    fetchLinkPreview,
  };
}